import gql from "graphql-tag";

export const REGISTER_MUTATION = gql`
  mutation registerTestator(
    $email: String
    $phone: String
    $uniqueIdentifier: String
    $password: String
    $acceptedTerms: Boolean!
    $referralCode: String
    $willCountry: WillCountryEnum!
    $acceptedCompetitionTerms: Boolean
    $testatorCompetitionReferralId: Int
    $omtId: String
    $adReferrer: String
    $fullReferrer: String
    $signupMethod: String!
    $ssoToken: String
  ) {
    registerTestator(
      email: $email
      phone: $phone
      uniqueIdentifier: $uniqueIdentifier
      password: $password
      acceptedTerms: $acceptedTerms
      referralCode: $referralCode
      willCountry: $willCountry
      acceptedCompetitionTerms: $acceptedCompetitionTerms
      testatorCompetitionReferralId: $testatorCompetitionReferralId
      omtId: $omtId
      adReferrer: $adReferrer
      fullReferrer: $fullReferrer
      signupMethod: $signupMethod
      ssoToken: $ssoToken
    ) {
      testatorId
      accessToken
      refreshToken
      userId
      belongsToCompany
      email
      phone
      uniqueIdentifier
      fullName
      advisorName
      advisorEmail
      companyName
      companyId
      companyLogoUrl
      willCountry
    }
  }
`;

export const LOGIN_MUTATION = gql`
  mutation login($uniqueIdentifier: String!, $password: String!) {
    login(uniqueIdentifier: $uniqueIdentifier, password: $password) {
      testatorId
      accessToken
      refreshToken
      email
      phone
      uniqueIdentifier
      fullName
      userId
      belongsToCompany
      advisorName
      advisorEmail
      companyName
      companyId
      companyLogoUrl
      willCountry
    }
  }
`;

export const SET_PASSWORD_AND_LOGIN_MUTATION = gql`
  mutation setPasswordAndLogin(
    $userLinkCode: String!
    $password: String!
    $acceptedTerms: Boolean
  ) {
    setPasswordAndLogin(
      userLinkCode: $userLinkCode
      password: $password
      acceptedTerms: $acceptedTerms
    ) {
      testatorId
      accessToken
      refreshToken
      uniqueIdentifier
      userId
      belongsToCompany
      email
      fullName
      advisorName
      advisorEmail
      companyName
      companyId
      companyLogoUrl
      willCountry
    }
  }
`;

export const REFRESH_ACCESS_TOKEN_MUTATION = gql`
  mutation refreshAccessToken($refreshToken: String!, $userId: ID!) {
    refreshAccessToken(refreshToken: $refreshToken, userId: $userId) {
      accessToken
      refreshToken
    }
  }
`;

export const CHANGE_PASSWORD_MUTATION = gql`
  mutation changePassword($id: ID!, $password: String!) {
    changePassword(id: $id, password: $password) {
      accessToken
      refreshToken
    }
  }
`;

export const LOGOUT_MUTATION = gql`
  mutation logout($id: ID!) {
    logout(id: $id) {
      success
    }
  }
`;

export const LOGIN_SSO_MUTATION = gql`
  mutation loginSso($token: String!, $platform: String!) {
    loginSso(token: $token, platform: $platform) {
      testatorId
      accessToken
      refreshToken
      email
      phone
      uniqueIdentifier
      fullName
      userId
      belongsToCompany
      advisorName
      advisorEmail
      companyName
      companyId
      companyLogoUrl
      willCountry
    }
  }
`;
